import React from "react";

export default function Web_Google_Charts() {
  return (
    <div>
      <h1>What is Google Charts</h1>
      <p>
        Route: <code>/web/google-charts</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
